import styled from 'styled-components';
import { convertHexToRGBA } from '@utils/usefulFuncs';

// The wash: a value's cell is the swatch, tinted by sign and magnitude. Shared so the member columns
// and a detail feed's Score column can't drift into two different greens.
//
// convertHexToRGBA returns false for a non-hex token, which falls back to no fill rather than
// emitting `background: false`.
export const washBackground = ({ theme, $tintToken, $tintAlpha }) => {
  if (!$tintToken) return '';
  const rgba = convertHexToRGBA(theme.themeColors[$tintToken], $tintAlpha);
  return rgba ? `background: ${rgba};` : '';
};

// Full height as well as full width, so a washed column reads as one strip rather than a row of
// floating swatches. The row's own padding keeps the washes off its borders.
export const washCellCss = `
  display: flex;
  align-items: center;
  gap: 5px;
  width: 100%;
  height: 100%;
  min-height: 22px;
  padding: 4px 8px;
  border-radius: 3px;
  font-variant-numeric: tabular-nums;
`;

export const WashCell = styled.span`
  ${washCellCss};
  ${washBackground};
`;
